<template>
  <div class="card">
    <div v-if="!$slots.header" :aria-expanded="active" class="card-header" role="tab" @click.prevent="activate">
      <a :aria-controls="`content-${itemId}`" :href="`#${itemId}`" data-parent="#accordion" data-toggle="collapse">
        <slot name="title">{{ title }}</slot>
        <i class="tim-icons icon-minimal-down"></i>
      </a>
    </div>

    <div v-if="$slots.header" class="card-header not-collapse" role="tab">
      <slot name="header">{{ title }}</slot>
    </div>

    <collapse-transition :duration="$slots.header ? 0 : animationDuration">
      <div v-show="active" :id="`content-${itemId}`" :aria-labelledby="title" class="collapsed" role="tabpanel">
        <div :class="bodyClasses" class="card-body">
          <slot></slot>
        </div>

        <slot v-if="noBody"></slot>

        <div v-if="$slots.footer" :class="footerClasses" class="card-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'CollapseItem',
  components: {
    CollapseTransition,
  },

  inject: {
    animationDuration: {
      default: 250,
    },

    multipleActive: {
      default: false,
    },

    addItem: {
      default: () => {},
    },

    removeItem: {
      default: () => {},
    },

    deactivateAll: {
      default: () => {},
    },
  },

  props: {
    title: {
      type: String,
      default: '',
      description: 'Collapse item title',
    },

    bodyClasses: {
      type: [String, Object, Array],
      description: 'Card body css classes',
    },

    id: String,
    noBody: {
      type: Boolean,
      default: false,
      description: 'Whether card should have wrapper body class',
    },

    footerClasses: {
      type: [String, Object, Array],
      description: 'Card footer css classes',
    },
  },

  data() {
    return {
      active: false,
    };
  },

  computed: {
    itemId() {
      return this.id || this.title;
    },
  },

  mounted() {
    this.addItem(this);
  },

  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeItem(this);
  },

  methods: {
    activate() {
      let wasActive = this.active;
      if (!this.multipleActive) {
        this.deactivateAll();
      }
      this.active = !wasActive;
    },
  },
};
</script>

<style scoped>
.accordion .card-header.not-collapse::after {
  content: none;
}

.accordion .card-header.not-collapse {
  cursor: default;
  padding: 1.25rem 1.5rem;
}
</style>
